// extracted by mini-css-extract-plugin
export default {"SubmitButton":"MessageSubmitButton_SubmitButton__aBy0L"};